import React, { useState, useEffect } from "react";

import { selectDateOrTime } from "../../../../../services/saleAnalysis-services";
import {
  Button,
  Chip,
  colors,
  Container,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import SalesDetialsType from "./SalesDetialsType";
import SalesDetailsForm from "./SalesDetailsForm";
import SalesDetailsTable from "./SalesDetailsTable";
import useFetchURL from "../../../../../components/Hooks/useFetchURL";
import { uri } from "../../../../../help/Api";
import TotalCard from "../../../../../components/TotalCard";
import { useHistory } from "react-router-dom";
import {
  useStylesHed,
  useStylesSpDial,
  useStylesUiElemment,
} from "../../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import DailyReportFilter from "../EveryDay/DailyReportFilter";
import { sto } from "../../../../../Context/InshData";
import axios from "axios";
import TafsailReportPrint from "../../../../../Reviews/Sales/Tafsele/TafsailReportPrint";
const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
  },
  itemW: {
    // display:'flex',
    width: "90%",
  },
  headerTitle: {
    backgroundColor: colors.green[50],
    textAlign: "center",
    fontSize: 20,
    width: "100%",
  },

  allWidth: {
    minWidth: 650,
  },
  checStyl: {
    marginTop: "17px",
    fontSize: "16px",
    padding: "-1px",
  },
  purchTotalCard: {
    backgroundColor: colors.blue[50],
    borderColor: colors.blue[300],
  },
}));

export default function SalesDetails(props) {
  const { AutoOptions, CustomerOptions, branch, setBranch, valueType, setValueType, isPurches } = props;

  let idBranch = AutoOptions.Branches[0].id;
  let nameBranch = AutoOptions.Branches[0].name;
  const SalesDetailsDefouls = {
    //selectType: selectTypes[0],
    timeF: moment(new Date()).startOf("day").format("HH:mm"),
    timeT: moment(new Date()).endOf("day").format("HH:mm"),
    dateFrom: moment(new Date()).format('YYYY-MM-DD'),
    timeFrom: moment(new Date()).format('HH:mm'),
    dateTo: moment(new Date()).format('YYYY-MM-DD'),
    timeTo: moment(new Date()).format('HH:mm'),
    selectTime: selectDateOrTime[0],
    cust: { id: -1, name: "الكل" },
    type: { id: -1, name: "الكل" },
    center: { id: -1, name: "الكل" },
    system: "sale",
    branch: { id: sto.User_typei == 1 ? -1 : idBranch, name: sto.User_typei == 1 ? "الكل" : nameBranch },
  };

  const [rptParams, setRptParams] = React.useState({ ...SalesDetailsDefouls, system: isPurches ? "purch" : "sale" });
  const classes = useStyles();
  const clasui = useStylesUiElemment();
  const clasSp = useStylesSpDial();
  const { t } = useTranslation(["forms", "translation"]);

  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const viewHandle = async () => {
    setData([]);
    setFetching(true);
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `RptSales/ReportDetails?sdate=${rptParams.dateFrom + ' ' + rptParams.timeFrom}
        &&edate=${rptParams.dateTo + ' ' + rptParams.timeTo}
        &&dtype=${rptParams.type.id}
        &&branch=${rptParams.branch?.id}
        &&customers=${rptParams.cust.id}
        &&date_time=${rptParams.selectTime.name}
        &&system=${rptParams?.system}
        &&center=${rptParams?.center?.id}`
    } else {
      Urls = `RptSales/ReportDetails?sdate=${rptParams.dateFrom + ' ' + rptParams.timeFrom}
        &&edate=${rptParams.dateTo + ' ' + rptParams.timeTo}
        &&dtype=${rptParams.type.id}
        &&branch=${rptParams.branch?.id}
        &&customers=${rptParams.cust.id}
        &&date_time=${rptParams.selectTime.name}
        &&system=${rptParams?.system}
        &&center=${rptParams?.center?.id}
        &&db_name=${sto?.db_name}`
    }
    await axios
      .get(
        uri + Urls
      )
      .then((res) => {
        setData(res.data);
        console.log(" the data is", res.data);
        setFetching(false);
      })
      .catch((err) => {
        viewHandleOld();
      });
  };
  const viewHandleOld = async () => {
    setData([]);
    setFetching(true);
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `RptSales/ReportDetails?sdate=${rptParams.dateFrom + ' ' + rptParams.timeFrom}
        &&edate=${rptParams.dateTo + ' ' + rptParams.timeTo}
        &&dtype=${rptParams.type.id}
        &&branch=${rptParams.branch?.id}
        &&customers=${rptParams.cust.id}
        &&date_time=${rptParams.selectTime.name}
        &&system=${rptParams?.system}`
    } else {
      Urls = `RptSales/ReportDetails?sdate=${rptParams.dateFrom + ' ' + rptParams.timeFrom}
        &&edate=${rptParams.dateTo + ' ' + rptParams.timeTo}
        &&dtype=${rptParams.type.id}
        &&branch=${rptParams.branch?.id}
        &&customers=${rptParams.cust.id}
        &&date_time=${rptParams.selectTime.name}
        &&system=${rptParams?.system}
        &&db_name=${sto?.db_name}`
    }
    await axios
      .get(
        uri + Urls
      )
      .then((res) => {
        setData(res.data);
        console.log(" the data is", res.data);
        setFetching(false);
      })
      .catch((err) => {
        setFetching(false);
        console.log(err);
        // toast.err("يوجد خطأ في الجلب");
        setData([]);
      });
  };
  const his = useHistory();
  const [dataPrint, setDataPrint] = useState({});
  const [infoPrint, setInfoPrint] = useState(false);
  const closePrint = (type) => {
    setDataPrint({});
    setInfoPrint(false);
  };

  const printHandle = () => {
    if (data.lenght == 0) {
      alert("لاتوجد بيانات");
    } else {
      const info = {
        data: data?.salesDetials,
        tot: data?.totals,
        from: "طريقة الدفع",
        title: isPurches ? "تقرير تفصيلي للمشتريات" : "تقرير تفصيلي للمبيعات",
        auto: {},
        fDate: rptParams.dateFrom,
        tDate: rptParams.dateTo,
        nDate: moment(new Date()).format("YYYY-MM-DD"),
        ElmntShow: true,
        typeName: rptParams.type.name,
        branch: rptParams.branch?.name,
        custName: rptParams.cust.name,
      };
      setDataPrint(info);
      setInfoPrint(true);

    }
  };

  let excel_name = "SalesDetailsReports";

  const excelHeaders = [
    { label: "الصنف", key: "symbol" },
    { label: "الكمية", key: "val1" },
    { label: "السعر", key: "exchange_price" },
    { label: "الخصم", key: "discount" },
    { label: "الضريبة", key: "taxval" },
    { label: "الصافي مع الضريبة", key: "amount" },
    { label: t("refno"), key: "refno" },
    { label: "العميل", key: "customer_name" },
    { label: "التفاصيل", key: "trans_name_ar" },
    { label: "طريقة الدفع", key: "name" },
  ];

  const onChangeData = (propName) => (event) => {
    setRptParams({ ...rptParams, [propName]: event.target.value });
  };
  const onChangeAutoData = (propName, newValue) => {
    setRptParams({ ...rptParams, [propName]: newValue });
  };
  return (
    <div className={classes.root}>
      <Grid container item xs={12}>
        <Typography
          size="small"
          className={classes.headerTitle}
          style={{
            backgroundColor: isPurches ? colors.blue[50] : colors.green[50], fontWeight: "bold",
          }}
          color="primary"
        >
          {isPurches ? "تقرير تفصيلي للمشتريات" : "تقرير تفصيلي للمبيعات"}
        </Typography>
      </Grid>
      <Typography
        component="div"
        style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
      >
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            paddingBottom: "0px",
            borderBottomColor: isPurches ? colors.blue[300] : colors.green[300],
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
          }}
        >
          <DailyReportFilter {...{ rptParams, setRptParams, isPurches }} />
          <SalesDetailsForm
            {...{
              AutoOptions,
              CustomerOptions,
              rptParams,
              onChangeData,
              onChangeAutoData,
              printHandle,
              branch,
              setBranch,
              valueType,
              setValueType,
              isPurches
            }}
          />
          <Grid
            container
            justifyContent="center"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            spacing={1}
          >
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<ScannerIcon />}
                size="large"
                style={
                  (inshst.sal.iconBtn,
                    { borderRadius: 0 })
                }
                className={isPurches ? [clasui.buttonPurch] : [clasui.buttonSal]}
                onClick={() => viewHandle()}
              >
                {t("forms:view")}
              </Button>
            </Grid>
            <Grid item >
              {data && !fetching && data.salesDetials && (
                <CSVLink
                  separator={";"}
                  filename={excel_name}
                  data={data.salesDetials}
                  headers={excelHeaders}
                >
                  {" "}
                  <Button
                    disabled={fetching}
                    variant="contained"
                    startIcon={<TableChart />}
                    size="large"
                    color="primary"
                    style={{ borderRadius: 0 }}
                    className={isPurches ? [clasui.buttonPurch] : [clasui.buttonSal]}
                  >
                    {"تصدير اكسل"}{" "}
                  </Button>
                </CSVLink>
              )}
            </Grid>
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<PrintIcon />}
                color="primary"
                size="large"
                className={isPurches ? [clasui.buttonPurch] : [clasui.buttonSal]}
                // className={[clasui.button, clasSp.clSec]}
                style={
                  (inshst.sal.iconBtn,
                    { borderRadius: 0 })
                }
                onClick={printHandle}
              >
                {t("forms:print")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                startIcon={<KeyboardReturnSharpIcon />}
                color="secondary"
                size="large"
                className={[clasui.button, clasSp.clcan]}
                style={
                  (inshst.sal.iconBtn,
                    { borderRadius: 0 })
                }
                onClick={() => his.goBack()}
              >
                {t("forms:exit")}
              </Button>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth={true} style={{ padding: "4px" }}>
          <Grid container spacing={1} style={{ paddingTop: "10px" }}>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: isPurches ? classes.purchTotalCard : null,
                  title: "عدد السجلات",
                  value: data?.salesDetials?.length.toFixed(2),
                }}
              />
            </Grid>

            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: isPurches ? classes.purchTotalCard : null,
                  title: isPurches ? "إجمالي مشتريات" : "إجمالي مبيعات",
                  value: data?.totals?.tot_sales.toFixed(2),
                }}
              />
            </Grid>

            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: isPurches ? classes.purchTotalCard : null,
                  title: "إجمالي المرتجع",
                  value: data?.totals?.tot_return.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: isPurches ? classes.purchTotalCard : null,
                  title: " الإجمالي قبل الضريبة",
                  value: data?.totals?.betfore_vat.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: isPurches ? classes.purchTotalCard : null,
                  title: "إجمالي الضريبة",
                  value: data?.totals?.vatTotal.toFixed(2),
                }}
              />
            </Grid>
            {/* 
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: isPurches ? classes.purchTotalCard : null,
                  title: " الإجمالي مع الضريبة",
                  value: data?.totals?.netAmount.toFixed(2),
                }}
              />
            </Grid> */}

            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: isPurches ? classes.purchTotalCard : null,
                  title: "إجمالي الصافي",
                  value: data?.totals?.netAmount.toFixed(2),
                }}
              />
            </Grid>
          </Grid>
        </Container>
        {/* <br /> */}
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            marginTop: "0.5rem"
          }}
        >
          <Grid container justifyContent="center">
            <Grid item container justifyContent="center" xs={12}>
              <BeatLoader loading={fetching} color={isPurches ? colors.blue[300] : colors.green[300]} />
              {!fetching && (
                <SalesDetailsTable
                  {...{
                    data: data?.salesDetials ? data.salesDetials : [],
                    isPurches,
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Container>
      </Typography>
      {infoPrint ? <TafsailReportPrint dataPrint={dataPrint} closePrint={closePrint} infoPrint={infoPrint} /> : null}
    </div>
  );
}
